import styled from 'styled-components';

export const Container = styled.div`
     display: flex;
     justify-content: end;
     position: fixed;
     bottom: 7rem;
     z-index: 9999999;
`;